import { render } from "./LiquidBasedCytology.vue?vue&type=template&id=b7395f38&scoped=true"
import script from "./LiquidBasedCytology.vue?vue&type=script&lang=js"
export * from "./LiquidBasedCytology.vue?vue&type=script&lang=js"

import "./LiquidBasedCytology.vue?vue&type=style&index=0&id=b7395f38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7395f38"]])

export default __exports__